<template>
    <div class="app-loading">
        <div class="wr-app-e-page-transition flex flex-col items-center justify-center">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                class="wr-app-loader__img ease-linear animate-pulse w-32 h-auto"
                width="61"
                height="45"
                viewBox="0 0 61 45"
                fill="none"
            >
                <g id="Group 335">
                    <path
                        id="Vector"
                        d="M0.74244 14.7873L8.2825 26.8438C8.89895 27.8321 10.3382 27.8321 10.9572 26.8438L18.4972 14.7873C19.1545 13.7378 18.3979 12.375 17.1599 12.375H2.07978C0.841786 12.375 0.0852323 13.7378 0.74244 14.7873Z"
                        fill="#A541FF"
                    ></path>
                    <path
                        id="Vector_2"
                        d="M32.7212 32.5956L39.5607 43.5312C40.1772 44.5195 41.6164 44.5195 42.2354 43.5312L60.2118 14.7873C60.869 13.7378 60.1125 12.375 58.8745 12.375H45.1928C44.6503 12.375 44.1434 12.6552 43.8555 13.1163L32.7212 30.9245C32.4002 31.4365 32.4002 32.0861 32.7212 32.5956Z"
                        fill="#A541FF"
                    ></path>
                    <path
                        id="Vector_3"
                        d="M11.8696 32.5826L18.7117 43.5234C19.3282 44.5117 20.7674 44.5117 21.3864 43.5234L40.0837 13.6229C40.4047 13.1109 40.4047 12.4614 40.0837 11.9519L33.2442 1.01373C32.6277 0.0253712 31.1885 0.0253712 30.5695 1.01373L11.8696 30.9116C11.5487 31.4236 11.5487 32.0732 11.8696 32.5826Z"
                        fill="#A541FF"
                    ></path>
                </g>
            </svg>
            <div class="text-3xl font-black my-4 text-center">
                <slot>Loading...</slot>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts"></script>

<style scoped>
.wr-app-e-page-transition {
    position: relative;
}

.app-loading {
    display: flex;
    position: fixed;
    top: 0;
    left: 0;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
    z-index: 10;
    background-color: rgba(255, 255, 255, 0.6);

    .loader__img {
        position: fixed;
        inset: 0;
        display: grid;
        place-items: center;
        z-index: 10;
        animation-fill-mode: both;
        animation-duration: var(--e-page-transition-animation-duration, 1000ms);
    }
}
</style>
